import { useState } from "react";
import { Play } from "lucide-react";
import { Eyebrow, SectionTitle } from "../Eyebrow";

const BFM_URL = "https://www.bfmtv.com/economie/professionnels/focus-entreprises/fod-le-pure-player-de-l-optimisation-des-frais-bancaires_AB-202501270025.html";
const VIDEO_TITLE = "Interview BFM Business — FOD : le pure player de l'optimisation des frais bancaires";

const VideoPlayer = () => {
    const [playing, setPlaying] = useState(false);
    return (
        <div className="flex-1 basis-[460px] min-w-0 aspect-video rounded-2xl overflow-hidden relative bg-navy" data-testid="bfm-video">
            {playing ? (
                <iframe
                    src="https://www.youtube.com/embed/IlUJPmvkMtU?autoplay=1&rel=0"
                    title={VIDEO_TITLE}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                    data-testid="bfm-video-iframe"
                    className="absolute inset-0 w-full h-full border-0"
                />
            ) : (
                <button
                    type="button"
                    onClick={() => setPlaying(true)}
                    data-testid="bfm-video-play"
                    aria-label={`Lire la vidéo : ${VIDEO_TITLE}`}
                    className="group absolute inset-0 w-full h-full"
                >
                    <img src="/media/video-bfm-thumb.jpg" alt="" loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.03]" />
                    <span className="absolute inset-0 bg-navy/35 flex flex-col items-center justify-center gap-3.5 text-cream">
                        <span className="w-[76px] h-[76px] rounded-full bg-gold flex items-center justify-center text-navy transition-transform group-hover:scale-110">
                            <Play size={28} fill="currentColor" strokeWidth={0} className="ml-1" />
                        </span>
                        <span className="text-sm font-semibold uppercase tracking-[0.12em]">Vu sur BFM TV</span>
                    </span>
                </button>
            )}
        </div>
    );
};

export const BfmVideo = () => (
    <section className="bg-cream border-t border-border-default" data-testid="apropos-media">
        <div className="mx-auto max-w-[1180px] px-4 md:px-8 lg:px-12 py-12 md:py-16 lg:py-[88px] flex flex-wrap gap-x-14 gap-y-8 items-center">
            <div className="flex-1 basis-[320px] flex flex-col gap-3.5">
                <Eyebrow>Médias</Eyebrow>
                <SectionTitle>
                    FOD{" "}
                    <a href={BFM_URL} target="_blank" rel="noopener noreferrer" data-testid="apropos-bfm-link" className="text-gold-text underline underline-offset-4 decoration-2">
                        vu sur BFM TV.
                    </a>
                </SectionTitle>
                <p className="m-0 text-base leading-[1.7] text-grey-text">
                    Découvrez notre vision et notre méthode d'optimisation des frais bancaires dans cette interview accordée à BFM Business.
                </p>
            </div>
            <VideoPlayer />
        </div>
    </section>
);
